import ProductTypesService from '../services/product-types.service';
import { ProductType } from './models/models';

export default {
  namespaced: true,
  state: {
    productTypeId: null,
    totalProductTypes: null,
    query: {
      filters: {},
      sort: [],
      page: 1,
      limit: 30,
    },
  },
  mutations: {
    productTypeId(state, productTypeId) {
      state.productTypeId = productTypeId;
    },
    totalProductTypes(state, totalProductTypes) {
      state.totalProductTypes = totalProductTypes;
    },
    queryProps(state, props) {
      state.query = Object.assign({}, state.query, props);
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getProductTypes');
    },
    newProductType({ commit }) {
      ProductType.new()
        .then((productType) => {
          commit('productTypeId', productType.id);
        });
    },
    updateProductTypeProps({ state }, props) {
      ProductType.update({
        where: state.productTypeId,
        data: props,
      });
    },
    getProductTypes({ commit, state }) {
      return ProductTypesService.getProductTypes(state.query)
        .then((res) => {
          commit('totalProductTypes', res.total);
          ProductType.create({ data: res.data });
        });
    },
    suggestProductTypes(store, query) {
      return ProductTypesService.suggestProductTypes(query);
    },
    getProductType({ commit }, id) {
      return ProductTypesService.getProductType(id)
        .then((productType) => {
          ProductType.insert({ data: [productType] })
            .then(() => {
              commit('productTypeId', productType.id);
            });
        });
    },
    createProductType({ getters }) {
      return ProductTypesService.createProductType(getters.productType);
    },
    updateProductType({ getters, dispatch }) {
      return ProductTypesService.updateProductType(getters.productType)
        .then((res) => {
          if (res.hasOwnProperty('productType_id')) {
            dispatch('getProductType', res.productType_id);
          }
          return res;
        });
    },
    deleteProductType({ getters }) {
      return ProductTypesService.deleteProductType(getters.productType)
        .then((res) => {
          if (res.hasOwnProperty('productType_id')) {
            ProductType.delete(res.productType_id);
          }
          return res;
        });
    },
  },
  getters: {
    productTypes() {
      return ProductType.query()
        .withAllRecursive()
        .all();
    },
    productType(state) {
      if (!state.productTypeId) {
        return null;
      }
      return ProductType.query()
        .find(state.productTypeId);
    },
  },
};
